export default {
    token: '',
    user: {},
}


// WEBPACK FOOTER //
// ./src/js/store/state.js